import { render, staticRenderFns } from "./GenericTHGUserTable.vue?vue&type=template&id=c2e65b76"
import script from "./GenericTHGUserTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenericTHGUserTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports